import { request } from '../client';

// Search results carry outlet-scoped price and stock, so they follow the same
// stale-location rule as the catalogue (see endpoints/catalog.js).
export const getSearchSuggestions = (q, options = {}) =>
  request('/search/suggestions', { geographySensitive: true, ...options, params: { q } });

// Trending terms are not scoped by the backend.
export const getTrendingSearches = () => request('/search/trending');

export const search = (q, limit, options = {}) =>
  request('/search', { geographySensitive: true, ...options, params: { q, limit } });
